import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={
            <Legal title="Privacy Policy">
              <p>Be Hire Ready respects your privacy. This policy explains what data we collect through enquiry forms (name, phone, email, message) and how we use it to respond to your training queries. We do not sell your data. Please contact us at hello@behireready.in for any privacy-related requests.</p>
              <p>Last updated: February 2026.</p>
            </Legal>
          } />
          <Route path="/terms" element={
            <Legal title="Terms & Conditions">
              <p>By using this website you agree to Be Hire Ready's terms. Programs, prices and offerings are subject to change. Fees paid are non-refundable once a program has commenced. All content on this site is owned by Be Hire Ready.</p>
              <p>Last updated: February 2026.</p>
            </Legal>
          } />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
